import * as React from 'react';
import { CheckmarkSvg } from '../../SvgIcons';
import Styles from "./SingleSelectable.css";

function MarkSelectable(_a) {
  var quantitySelected = _a.quantitySelected,
      option = _a.option;

  if (!quantitySelected) {
    return null;
  }

  return quantitySelected === option.data.length ? React.createElement(CheckmarkSvg, {
    className: Styles.checkMark
  }) : React.createElement("span", {
    className: Styles.dirtyMark,
    "data-test": "dirty-mark"
  });
}

var SingleOptionComponent = function SingleOptionComponent(_a) {
  var option = _a.option,
      className = _a.className,
      handlerClick = _a.handlerClick,
      quantitySelected = _a.quantitySelected;
  return React.createElement("li", {
    key: option.id,
    className: className,
    onClick: handlerClick
  }, React.createElement("span", {
    className: Styles.nameOption
  }, option.name), React.createElement(MarkSelectable, {
    option: option,
    quantitySelected: quantitySelected
  }));
};

export default SingleOptionComponent;